module.exports = __webpack_public_path__ + "img/logo.a33125d5.png";